const carouselItems = [
  {
    title: '2026暑期档观影指南',
    desc: '暑假必看大片全攻略，从动作冒险到温情动画，一份清单带你解锁整个暑期档的精彩影视内容。',
    tag: '专题策划',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20summer%20movie%20collage%20with%20warm%20golden%20hour%20lighting%2C%20abstract%20film%20strip%20elements%2C%20soft%20bokeh%20effects%2C%20theater%20ambiance%20in%20coral%20and%20amber%20tones%2C%20artistic%20composition%2C%20no%20text&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '国漫崛起特别盘点',
    desc: '从大圣归来到深海，中国动画电影的十年进阶之路。糖心影视精选国漫精品，见证东方美学的银幕绽放。',
    tag: '深度盘点',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20style%20collage%20with%20ink%20wash%20painting%20elements%2C%20floating%20mythical%20figures%2C%20warm%20coral%20and%20gold%20gradient%2C%20ethereal%20atmosphere%2C%20artistic%20cinematic%20composition%2C%20no%20text%20no%20people&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '悬疑剧迷的终极片单',
    desc: '高智商推理、心理惊悚、犯罪侦查，糖心影视为你甄选全网口碑炸裂的悬疑神作，每一部都让你欲罢不能。',
    tag: '类型精选',
    img: 'https://readdy.ai/api/search-image?query=A%20moody%20cinematic%20noir%20atmosphere%20with%20dramatic%20shadows%2C%20warm%20amber%20light%20streaks%2C%20abstract%20mystery%20elements%2C%20film%20noir%20aesthetic%20in%20dark%20coral%20and%20deep%20gold%20tones%2C%20artistic%20and%20atmospheric%2C%20no%20text&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '经典港片修复特辑',
    desc: '那些年我们追过的港片经典，高清修复版本陆续上线糖心影视。重温发哥、星爷的银幕传奇时刻。',
    tag: '经典重温',
    img: 'https://readdy.ai/api/search-image?query=Retro%20Hong%20Kong%20cinema%20nostalgic%20vibe%20with%20neon%20light%20reflections%2C%20vintage%20film%20poster%20aesthetics%2C%20warm%20coral%20and%20golden%20hues%2C%20cinematic%20composition%20with%20soft%20glow%2C%20artistic%20atmosphere%2C%20no%20text&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    title: '高分纪录片观影指南',
    desc: '拓展视野、启迪思考，糖心影视精选国内外高分纪录片，涵盖自然、历史、科技、人文四大主题。',
    tag: '品质推荐',
    img: 'https://readdy.ai/api/search-image?query=A%20serene%20documentary%20style%20composition%20with%20nature%20and%20cultural%20elements%2C%20warm%20earth%20tones%20blending%20with%20coral%20accents%2C%20soft%20diffused%20lighting%2C%20contemplative%20cinematic%20mood%2C%20elegant%20minimal%20design%2C%20no%20text&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
  {
    title: '周末家庭观影推荐',
    desc: '适合全家人一起看的温馨好片，糖心影视为你挑选亲子共赏的优质内容，让周末时光更加甜蜜美好。',
    tag: '亲子精选',
    img: 'https://readdy.ai/api/search-image?query=A%20warm%20cozy%20family%20living%20room%20with%20soft%20ambient%20lighting%2C%20abstract%20film%20projection%20glow%2C%20comfortable%20atmosphere%20in%20coral%20and%20golden%20tones%2C%20cinematic%20but%20homey%20aesthetic%2C%20no%20people%20no%20text&width=800&height=500&seq=carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            精选专题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            糖心影视编辑团队精心策划的深度专题内容，带你发现更多观影乐趣
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <article
              key={item.title}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all cursor-pointer"
            >
              <div className="relative w-full h-[220px] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 via-transparent to-transparent"></div>
                <span className="absolute top-4 left-4 px-3 py-1 text-[11px] font-semibold bg-primary-500 text-background-50 rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}